import { isEmpty } from "lodash-es";
import type { PropType } from "vue";
import type { MicroSchemaBase } from "~/modules/micro-schema/interfaces";

export const MicroSchema = defineComponent({
  name: "MicroSchema",
  props: {
    ldJsonData: {
      type: [Object, undefined] as PropType<MicroSchemaBase | undefined>,
      required: false,
      default: () => undefined,
    },
  },
  setup(props) {
    if (isEmpty(props.ldJsonData)) {
      return undefined;
    }

    const scriptData = computed(() => {
      if (props.ldJsonData) {
        const jsonString = JSON.stringify(props.ldJsonData);
        return [
          {
            id: hashCode(jsonString),
            type: "application/ld+json",
            innerHTML: jsonString,
          },
        ];
      }

      return [];
    });

    const activeEntry = useHead({
      script: scriptData,
    });

    onUnmounted(() => {
      activeEntry?.dispose();
      scriptData.value.forEach((el) => {
        document.getElementById(el.id)?.remove();
      });
    });
  },
  render() {
    return undefined;
  },
});
